import { render, staticRenderFns } from "./VerifyingInfo.vue?vue&type=template&id=50c6d4fc"
import script from "./VerifyingInfo.vue?vue&type=script&lang=js"
export * from "./VerifyingInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports